import { Button } from '@/components/ui/button'
import Link from 'next/link'

export default function CallToAction() {
    return (
        <section className="w-full">
            <div className="mx-auto max-w-5xl px-6">
                <div className="text-center">
                    {/* Removed h2 and p elements */}
                    {/* <h2 className="text-balance text-4xl font-semibold lg:text-5xl">Start Monitoring Today</h2> */}
                    {/* <p className="mt-4">Get real-time insights into your brand's media presence and sentiment.</p> */}

                    <div className="mt-12 flex flex-wrap justify-center gap-4">
                        <Button asChild size="lg" className="bg-gradient-to-r from-indigo-600 to-purple-700 hover:from-indigo-700 hover:to-purple-800 text-white">
                            <Link href="/dashboard">
                                <span className="font-bold">Get Started</span>
                            </Link>
                        </Button>

                        <Button asChild size="lg" variant="outline">
                            <Link href="/">
                                <span className="font-bold">Book Demo</span>
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    )
} 